import exportFromJSON from 'export-from-json'
import { ArticuloProp } from '../interfaces'
import dayjs from 'dayjs'

export const exportarArticulosCSV = async (
  data: ArticuloProp[],
  updateData: boolean,
): Promise<void> => {
  if (!data || data.length === 0) {
    throw new Error('NO se han encontrado registros.')
  }
  // Convert all string values to UTF-8 NFC to help with accents in CSV export
  const normalizeString = (value: any) =>
    typeof value === 'string' ? value.normalize('NFC') : value

  const rows = data.map((articulo) => {
    if (updateData) {
      return {
        codigoArticulo: normalizeString(articulo.codigoArticulo || ''),
        nombreArticulo: normalizeString(articulo.nombreArticulo || ''),
        descripcionArticulo: normalizeString(articulo.descripcionArticulo || ''),
        codigoActividad: normalizeString(
          articulo.sinProductoServicio?.codigoActividad || '',
        ),
        codigoSinProducto: normalizeString(
          articulo.sinProductoServicio.codigoProducto || '',
        ),
        codigoTipoArticulo: normalizeString(articulo.tipoArticulo?.codigo || ''),
        articuloCompra: articulo.articuloCompra ? 'SI' : 'NO',
        articuloInventario: articulo.articuloInventario ? 'SI' : 'NO',
        articuloVenta: articulo.articuloVenta ? 'SI' : 'NO',
        complemento: articulo.complemento ? 'SI' : 'NO',
        verificarStock: articulo.verificarStock ? 'SI' : 'NO',
        activo: articulo.activo ? 'SI' : 'NO',
        codigoProveedor: Array.isArray(articulo.proveedor)
          ? articulo.proveedor.map((p: any) => p.codigo).join(', ')
          : articulo.proveedor || '',
      }
    } else {
      return {
        codigoArticulo: normalizeString(articulo.codigoArticulo || ''),
        nombreArticulo: normalizeString(articulo.nombreArticulo || ''),
        descripcionArticulo: normalizeString(articulo.descripcionArticulo || ''),
        actividadEconomica: normalizeString(
          articulo.sinProductoServicio?.descripcionProducto || '',
        ),
        codigoActividad: normalizeString(
          articulo.sinProductoServicio?.codigoActividad || '',
        ),
        codigoSinProducto: normalizeString(
          articulo.sinProductoServicio.codigoProducto || '',
        ),
        codigoTipoArticulo: normalizeString(articulo.tipoArticulo?.codigo || ''),
        tipoArticulo: normalizeString(articulo.tipoArticulo?.descripcion || ''),
        claseArticulo: normalizeString(articulo.claseArticulo || ''),
        gestionArticulo: normalizeString(articulo.gestionArticulo || ''),
        articuloCompra: articulo.articuloCompra ? 'SI' : 'NO',
        articuloInventario: articulo.articuloInventario ? 'SI' : 'NO',
        articuloVenta: articulo.articuloVenta ? 'SI' : 'NO',
        complemento: articulo.complemento ? 'SI' : 'NO',
        verificarStock: articulo.verificarStock ? 'SI' : 'NO',
        activo: articulo.activo ? 'SI' : 'NO',
        estado: normalizeString(articulo.state || ''),
        codigoProveedor: Array.isArray(articulo.proveedor)
          ? articulo.proveedor.map((p: any) => p.codigo).join(', ')
          : articulo.proveedor || '',
        proveedores: Array.isArray(articulo.proveedor)
          ? articulo.proveedor.map((p: any) => p.nombre).join(', ')
          : articulo.proveedor || '',
      }
    }
  })

  const fileName = updateData
    ? `articulos_actualizar_${dayjs().format('YYYYMMDD_HHmmss')}`
    : `articulos_${dayjs().format('YYYYMMDD_HHmmss')}`
  const exportType = exportFromJSON.types.csv

  // Use a library like export-from-json to handle the export
  // Prepend UTF-8 BOM to ensure accents are recognized in Excel and other editors
  const options = {
    data: rows,
    fileName,
    exportType,
    withBOM: true,
    delimiter: ';' as ';',
  }
  exportFromJSON(options)
}
